import * as React from "react";
import { TaskTreeEditor } from "./TaskTreeEditor";
import { Header } from "src/components/Header";
import { Page } from "src/components/Page";
import { PlusIcon } from "lucide-react";
import { createEmptyHabit } from "src/database/factories";
import { Tree } from "src/utils/Tree";
import { useLiveQuery } from "dexie-react-hooks";
import { getTemplate } from "src/database/queries/habits";
import { moveItem } from "src/database/queries/items";
import { taskFormContext } from "./TaskForm/taskFormContext";
import { Ordering } from "src/database/models/Ordering";

export function Habits() {
  const taskForm = React.useContext(taskFormContext);
  const initialHabits = useLiveQuery(() => getTemplate());
  const habits = Tree.build(initialHabits ?? []);

  return (
    <Page maxWidth={600}>
      <Header title="Habits">
        <Header.Button
          icon={PlusIcon}
          onClick={() =>
            taskForm.create(
              createEmptyHabit({
                order: Ordering.insertAt(habits, (h) => h.order, 0),
              }),
            )
          }
        >
          New Habit
        </Header.Button>
      </Header>
      <TaskTreeEditor items={habits} onMoveItem={moveItem} />
    </Page>
  );
}
